/// <reference types="@angular/localize" />



import { DatePipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { ErrorHandler, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { OAuthModule } from 'angular-oauth2-oidc';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { SwiperModule } from 'swiper/angular';

import { provideRouter, withRouterConfig } from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { GlobalErrorHandler } from './app/core/global-error-handler';
import { AuthService } from './app/shared/auth/services/auth.service';
import { RequestInterceptor } from './app/shared/auth/services/interceptor.service';
import { AuthGuardService } from './app/shared/guards/auth-guard.service';
import { NonAuthGuardService } from './app/shared/guards/non-auth-guard.service';
import { providerGoogleAnalytics, providerGoogleAnalyticsTracker } from './app/shared/providers/google-analytics.provider';
import { providerAppVersionCheck } from './app/shared/providers/app-version.provider';
import { AlunoService } from './app/shared/services/alunos.service';
import { AppInsightsService } from './app/shared/services/app-insights.service';
import { ArquivoService } from './app/shared/services/arquivo.service';
import { CategoriaService } from './app/shared/services/categoria.service';
import { ChamadoService } from './app/shared/services/chamado.service';
import { ConcluirService } from './app/shared/services/concluir.service';
import { ConvivaErrorHandlingService } from './app/shared/services/convivaErrorHandlingService';
import { DialogService } from './app/shared/services/dialog.service';
import { EmailService } from './app/shared/services/email.service';
import { EscolaService } from './app/shared/services/escola.service';
import { FiltroService } from './app/shared/services/filtro.service';
import { FuncionarioService } from './app/shared/services/funcionarios.service';
import { NaoOcorrenciaService } from './app/shared/services/nao-ocorrencia.service';
import { PerfilService } from './app/shared/services/perfil.service';
import { PsicologoUtilsService } from './app/shared/services/psicologo-utils.service';
import { PsicologoService } from './app/shared/services/psicologo.service';
import { UtilsService } from './app/shared/services/utils.service';
import { GenericValidator } from './app/shared/validations/genericValidators';


registerLocaleData(localePt, 'pt');

bootstrapApplication(AppComponent, {
  providers: [

    importProvidersFrom(BrowserModule, FormsModule, ReactiveFormsModule, NgSelectModule, SwiperModule, NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }), ToastrModule.forRoot({ timeOut: 6000 ,positionClass:'toast-top-middle' }), NgbModule, NgxMaskDirective, NgxMaskPipe, OAuthModule.forRoot(), DataTablesModule, NgbPaginationModule),
    AppInsightsService,
    EscolaService,
    CategoriaService,
    ArquivoService,
    ConvivaErrorHandlingService,
    AlunoService,
    PerfilService,
    PsicologoService,
    provideNgxMask(),
    GenericValidator,
    ChamadoService,
    FuncionarioService,
    AuthService,
    AuthGuardService,
    NonAuthGuardService,
    NaoOcorrenciaService,
    ConcluirService,
    DialogService,
    UtilsService,
    {
      provide: DeviceDetectorService,
      useClass: DeviceDetectorService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    DatePipe,
    FiltroService,
    EmailService,
    PsicologoUtilsService,
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    providerGoogleAnalytics,
    providerGoogleAnalyticsTracker,
    providerAppVersionCheck
  ]
})
  .catch(err => console.error(err));

